
import {Component, Prop, Vue} from "vue-property-decorator";
import CashboxUpdateForm from "@/form/finance/cashbox/CashboxUpdateForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import moment from 'moment';
@Component({
  components: {FormGroup},
  methods: {moment}
})
export default class CashboxUpdateComponent extends Vue {
  @Prop() readonly form!: CashboxUpdateForm;

  searchTarget(val: any): void {
  }

  onChange(event: any): void {
  }

  deleteCashbox(id: number){
    this.$emit('deleteCashbox', id);
  }
}
